var Backbone, FAQTrendingArticlesView, FaqTrendingArticlesTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

Backbone = require('backbone');

Backbone.$ = $;

FaqTrendingArticlesTemplate = require('../../trending_articles.html.mustache');

FAQTrendingArticlesView = (function(superClass) {
  extend(FAQTrendingArticlesView, superClass);

  function FAQTrendingArticlesView() {
    return FAQTrendingArticlesView.__super__.constructor.apply(this, arguments);
  }

  FAQTrendingArticlesView.prototype.initialize = function() {
    this.I18nScope = 'modules.faq';
    this.template = FaqTrendingArticlesTemplate;
    return this.container = $('#trending-articles');
  };

  FAQTrendingArticlesView.prototype.events = {
    "click .article-header": "toggleArticleSummary",
    "click .rating": "handleRatingClicked"
  };

  FAQTrendingArticlesView.prototype.toggleArticleSummary = function(event) {
    var $target, id;
    $target = $(event.target).closest('.article-header');
    id = $target.find('.article').attr('articleId');
    this.resetAllArticlesExceptTarget(id);
    $("#" + id).toggle();
    $target.find('.icon-arrow-right').toggle();
    $target.find('.icon-arrow-down').toggle();
    return scrollTo($target);
  };

  FAQTrendingArticlesView.prototype.resetAllArticlesExceptTarget = function(targetId) {
    return _.each($('.article'), (function(_this) {
      return function(article) {
        var $target, id;
        id = $(article).attr('articleId');
        if (id !== targetId) {
          $target = $(article).closest('.article-header');
          $("#" + id).hide();
          $target.find('.icon-arrow-right').show();
          return $target.find('.icon-arrow-down').hide();
        }
      };
    })(this));
  };

  FAQTrendingArticlesView.prototype.render = function() {
    return this.toHtml();
  };

  FAQTrendingArticlesView.prototype.handleRatingClicked = function(event) {
    var $target;
    $target = $(event.target).closest('.rating');
    $target.find('.ratings').hide();
    $target.find('.thanks').show();
    return true;
  };

  FAQTrendingArticlesView.prototype.toHtml = function() {
    var ref;
    this.$el.html(toHtml(this.template, {
      trendingArticleList: (ref = this.model.get('faqMain')) != null ? ref.trending_articles : void 0
    }, this.I18nScope));
    return this.container.html(this.el);
  };

  return FAQTrendingArticlesView;

})(Backbone.View);

module.exports = FAQTrendingArticlesView;

//# sourceMappingURL=data:application/json;base64,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
